var Backbone, FAQTrendingArticlesView, FaqTrendingArticlesTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

FaqTrendingArticlesTemplate = require('../../trending_articles.html.mustache');

FAQTrendingArticlesView = (function(superClass) {
  extend(FAQTrendingArticlesView, superClass);

  function FAQTrendingArticlesView() {
    return FAQTrendingArticlesView.__super__.constructor.apply(this, arguments);
  }

  FAQTrendingArticlesView.prototype.initialize = function() {
    this.I18nScope = 'modules.faq';
    this.template = FaqTrendingArticlesTemplate;
    return this.container = $('#trending-articles');
  };

  FAQTrendingArticlesView.prototype.events = {
    "click .article-header": "toggleArticleSummary",
    "click .rating": "handleRatingClicked"
  };

  FAQTrendingArticlesView.prototype.toggleArticleSummary = function(event) {
    var $target, id;
    $target = $(event.target).closest('.article-header');
    id = $target.find('.article').attr('articleId');
    this.resetAllArticlesExceptTarget(id);
    $("#" + id).toggle();
    $target.find('.icon-arrow-right').toggle();
    $target.find('.icon-arrow-down').toggle();
    return scrollTo($target);
  };

  FAQTrendingArticlesView.prototype.resetAllArticlesExceptTarget = function(targetId) {
    return _.each($('.article'), (function(_this) {
      return function(article) {
        var $target, id;
        id = $(article).attr('articleId');
        if (id !== targetId) {
          $target = $(article).closest('.article-header');
          $("#" + id).hide();
          $target.find('.icon-arrow-right').show();
          return $target.find('.icon-arrow-down').hide();
        }
      };
    })(this));
  };

  FAQTrendingArticlesView.prototype.render = function() {
    return this.toHtml();
  };

  FAQTrendingArticlesView.prototype.handleRatingClicked = function(event) {
    var $target;
    $target = $(event.target).closest('.rating');
    $target.find('.ratings').hide();
    $target.find('.thanks').show();
    return true;
  };

  FAQTrendingArticlesView.prototype.toHtml = function() {
    var ref;
    this.$el.html(toHtml(this.template, {
      trendingArticleList: (ref = this.model.get('faqMain')) != null ? ref.trending_articles : void 0
    }, this.I18nScope));
    return this.container.html(this.el);
  };

  return FAQTrendingArticlesView;

})(Backbone.View);

module.exports = FAQTrendingArticlesView;

//# sourceMappingURL=data:application/json;base64,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
